import React from "react";
import MuiPagination from "@material-ui/lab/Pagination";

import { paginationStyles } from "./pagination.styles";
import { IPagination } from "./pagination.types";

import { useURLQueryString } from "../../hooks/useUrlQueryString";

export const Pagination = ({ callback, controlledParams, count }: IPagination) => {
  const classes = paginationStyles();
  const {
    getValues,
    pushHistory,
    setParams,
    values: { page = [1] },
  } = useURLQueryString(controlledParams);

  if (count <= 1) {
    return null;
  }

  const currentPage = Number(page[0]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    if (value === currentPage) {
      return;
    }

    setParams([{ name: "page", value }]);
    !!callback && callback(getValues());
    !callback && pushHistory();
  };

  return (
    <MuiPagination
      className={classes.pagination}
      count={count}
      onChange={handleChange}
      page={currentPage}
    />
  );
};
